module.exports = __webpack_public_path__ + "img/icon-close.c095d064.svg";